export const messages = {
  en: {
    adminStaffDetail: {
      title: 'Staff Information',
      staffId: 'Staff ID',
      userName: 'Name',
      idCard: 'ID Card',
      tel: 'Phone',
      sex: 'Gender',
      male: 'Male',
      female: 'Female',
      address: 'Address',
      privilege: 'Organization Privileges',
      classes: 'Schedule',
      attendance: 'Attendance',
      repair: 'Repair',
      inspection: 'Inspection',
      maintainance: 'Maintenance',
      purchaseApply: 'Purchase',
      itemOutApply: 'Item Out',
      hisFee: 'Fee Receipt',
      applyReturnFee: 'Refund Receipt',
      contract: 'Draft Contract',
      appAuth: 'Staff Authentication',
      accessControl: 'Face Synchronization',
      fetchError: 'Failed to fetch staff information'
    },
    staffDetailPrivilege: {
      orgs: 'Organizations',
      orgName: 'Organization Name',
      relCdName: 'Relationship Code',
      roles: 'Roles',
      privileges: 'Privileges',
      fetchPrivilegesError: 'Failed to fetch privileges',
      fetchOrgsError: 'Failed to fetch organizations',
      fetchRolesError: 'Failed to fetch roles'
    },
    staffDetailClasses: {
      enterDate: 'Enter Date (YYYY-MM)',
      rest: 'Rest',
      fetchError: 'Failed to fetch schedule classes'
    },
    staffDetailAttendance: {
      enterDate: 'Enter Date (YYYY-MM)',
      checkIn: 'Check In',
      checkOut: 'Check Out',
      attendanceLog: 'Attendance Log',
      notYet: 'Not Yet',
      noAttendance: 'No Attendance',
      fetchError: 'Failed to fetch attendance data'
    },
    staffAttendanceDetail: {
      title: 'Attendance Log',
      face: 'Face Image',
      staffName: 'Staff Name',
      clockTime: 'Clock Time',
      fetchError: 'Failed to fetch attendance log'
    },
    staffDetailRepair: {
      undoOrder: 'Pending',
      doneOrder: 'Completed',
      repairId: 'Repair ID',
      location: 'Location',
      repairType: 'Repair Type',
      maintenanceType: 'Maintenance Type',
      paidService: 'Paid Service',
      freeService: 'Free Service',
      materialRequired: 'Material Required',
      noMaterial: 'No Material',
      repairPerson: 'Repair Person',
      contact: 'Contact',
      appointmentTime: 'Appointment Time',
      status: 'Status',
      timedTask: 'Timed Task',
      fetchError: 'Failed to fetch repair data'
    },
    staffDetailInspection: {
      notStarted: 'Not Started',
      inProgress: 'In Progress',
      completed: 'Completed',
      taskDetailId: 'Task Detail ID',
      inspectionName: 'Inspection Name',
      inspectionPlanName: 'Plan Name',
      routeName: 'Route Name',
      planTime: 'Plan Time',
      pointTime: 'Point Time',
      actualInspectionTime: 'Actual Inspection Time',
      inspectionState: 'Inspection State',
      planUserName: 'Plan User',
      actualUserName: 'Actual User',
      signType: 'Sign Type',
      taskState: 'Task State',
      description: 'Description',
      photos: 'Photos',
      createTime: 'Create Time',
      location: 'Location',
      noLocation: 'No location data available',
      fetchError: 'Failed to fetch inspection data'
    },
    staffDetailMaintainance: {
      notStarted: 'Not Started',
      pendingCheck: 'Pending Check',
      completed: 'Completed',
      taskDetailId: 'Task Detail ID',
      machineName: 'Machine Name',
      planName: 'Plan Name',
      standardName: 'Standard Name',
      planUserName: 'Plan User',
      planTime: 'Plan Time',
      actualInspectionTime: 'Actual Inspection Time',
      actualUserName: 'Actual User',
      taskState: 'Task State',
      description: 'Description',
      photos: 'Photos',
      createTime: 'Create Time',
      fetchError: 'Failed to fetch maintenance data'
    },
    staffDetailPurchaseApply: {
      applyOrderId: 'Apply Order ID',
      userName: 'User Name',
      endUserName: 'End User Name',
      createUserName: 'Create User Name',
      resourceNames: 'Resource Names',
      createTime: 'Create Time',
      warehousingWay: 'Warehousing Way',
      direct: 'Direct',
      purchase: 'Purchase',
      urgent: 'Urgent',
      stateName: 'State',
      fetchError: 'Failed to fetch purchase apply data'
    },
    staffDetailItemOutApply: {
      applyOrderId: 'Apply Order ID',
      resourceNames: 'Resource Names',
      userName: 'User Name',
      createUserName: 'Create User Name',
      createTime: 'Create Time',
      stateName: 'State',
      warehousingWay: 'Warehousing Way',
      direct: 'Direct',
      review: 'Review',
      fetchError: 'Failed to fetch item out apply data'
    },
    staffDetailHisFee: {
      feeName: 'Fee Name',
      payerObjName: 'Payer Object',
      cycles: 'Cycles',
      amount: 'Amount',
      acctAmount: 'Account Amount',
      primeRateName: 'Prime Rate',
      feePeriod: 'Fee Period',
      createTime: 'Create Time',
      cashierName: 'Cashier Name',
      stateName: 'State',
      remark: 'Remark',
      fetchError: 'Failed to fetch fee details'
    },
    staffDetailApplyReturnFee: {
      selectState: 'Select State',
      returnFeeId: 'Return Fee ID',
      detailId: 'Detail ID',
      feeTypeCdName: 'Fee Type',
      payerObjName: 'Payer Object',
      cycles: 'Cycles',
      receivableAmount: 'Receivable Amount',
      receivedAmount: 'Received Amount',
      createTime: 'Create Time',
      reason: 'Reason',
      applyPersonName: 'Apply Person',
      stateName: 'State',
      auditPersonName: 'Audit Person',
      fetchError: 'Failed to fetch return fee data',
      fetchDictError: 'Failed to fetch dictionary data'
    },
    staffDetailContract: {
      contractId: 'Contract ID',
      contractNo: 'Contract No',
      contractName: 'Contract Name',
      partyA: 'Party A',
      partyB: 'Party B',
      contractPeriod: 'Contract Period',
      stateName: 'State',
      fetchError: 'Failed to fetch contract data'
    },
    staffDetailAppAuth: {
      authId: 'Auth ID',
      appName: 'App Name',
      authTime: 'Auth Time',
      stateName: 'State',
      fetchError: 'Failed to fetch app auth data'
    },
    staffDetailAccessControl: {
      accessId: 'Access ID',
      deviceName: 'Device Name',
      syncTime: 'Sync Time',
      stateName: 'State',
      fetchError: 'Failed to fetch access control data'
    }
  },
  zh: {
    adminStaffDetail: {
      title: '员工信息',
      staffId: '编号',
      userName: '名称',
      idCard: '身份证',
      tel: '手机',
      sex: '性别',
      male: '男',
      female: '女',
      address: '住址',
      privilege: '组织权限',
      classes: '排班',
      attendance: '考勤',
      repair: '维修',
      inspection: '巡检',
      maintainance: '保养',
      purchaseApply: '采购',
      itemOutApply: '领用',
      hisFee: '收费单',
      applyReturnFee: '退费单',
      contract: '起草合同',
      appAuth: '员工认证',
      accessControl: '人脸同步',
      fetchError: '获取员工信息失败'
    },
    staffDetailPrivilege: {
      orgs: '组织',
      orgName: '组织名称',
      relCdName: '关系代码',
      roles: '角色',
      privileges: '权限',
      fetchPrivilegesError: '获取权限失败',
      fetchOrgsError: '获取组织失败',
      fetchRolesError: '获取角色失败'
    },
    staffDetailClasses: {
      enterDate: '输入日期 (YYYY-MM)',
      rest: '休息',
      fetchError: '获取排班数据失败'
    },
    staffDetailAttendance: {
      enterDate: '输入日期 (YYYY-MM)',
      checkIn: '签到',
      checkOut: '签退',
      attendanceLog: '考勤记录',
      notYet: '尚未到达',
      noAttendance: '无考勤',
      fetchError: '获取考勤数据失败'
    },
    staffAttendanceDetail: {
      title: '考勤记录',
      face: '人脸图像',
      staffName: '员工名称',
      clockTime: '打卡时间',
      fetchError: '获取考勤记录失败'
    },
    staffDetailRepair: {
      undoOrder: '待处理',
      doneOrder: '已完成',
      repairId: '维修ID',
      location: '地点',
      repairType: '维修类型',
      maintenanceType: '维护类型',
      paidService: '付费服务',
      freeService: '免费服务',
      materialRequired: '需要材料',
      noMaterial: '无需材料',
      repairPerson: '维修人员',
      contact: '联系方式',
      appointmentTime: '预约时间',
      status: '状态',
      timedTask: '定时任务',
      fetchError: '获取维修数据失败'
    },
    staffDetailInspection: {
      notStarted: '未开始',
      inProgress: '进行中',
      completed: '已完成',
      taskDetailId: '任务详情ID',
      inspectionName: '巡检名称',
      inspectionPlanName: '计划名称',
      routeName: '路线名称',
      planTime: '计划时间',
      pointTime: '点时间',
      actualInspectionTime: '实际巡检时间',
      inspectionState: '巡检状态',
      planUserName: '计划用户',
      actualUserName: '实际用户',
      signType: '签到类型',
      taskState: '任务状态',
      description: '描述',
      photos: '照片',
      createTime: '创建时间',
      location: '位置',
      noLocation: '无位置数据',
      fetchError: '获取巡检数据失败'
    },
    staffDetailMaintainance: {
      notStarted: '未开始',
      pendingCheck: '待审核',
      completed: '已完成',
      taskDetailId: '任务详情ID',
      machineName: '设备名称',
      planName: '计划名称',
      standardName: '标准名称',
      planUserName: '计划用户',
      planTime: '计划时间',
      actualInspectionTime: '实际巡检时间',
      actualUserName: '实际用户',
      taskState: '任务状态',
      description: '描述',
      photos: '照片',
      createTime: '创建时间',
      fetchError: '获取保养数据失败'
    },
    staffDetailPurchaseApply: {
      applyOrderId: '申请订单ID',
      userName: '用户名',
      endUserName: '最终用户名',
      createUserName: '创建用户名',
      resourceNames: '资源名称',
      createTime: '创建时间',
      warehousingWay: '入库方式',
      direct: '直接',
      purchase: '采购',
      urgent: '紧急',
      stateName: '状态',
      fetchError: '获取采购申请数据失败'
    },
    staffDetailItemOutApply: {
      applyOrderId: '申请订单ID',
      resourceNames: '资源名称',
      userName: '用户名',
      createUserName: '创建用户名',
      createTime: '创建时间',
      stateName: '状态',
      warehousingWay: '入库方式',
      direct: '直接',
      review: '审核',
      fetchError: '获取领用申请数据失败'
    },
    staffDetailHisFee: {
      feeName: '费用名称',
      payerObjName: '付款对象',
      cycles: '周期',
      amount: '金额',
      acctAmount: '账户金额',
      primeRateName: '主要费率',
      feePeriod: '费用周期',
      createTime: '创建时间',
      cashierName: '收银员名称',
      stateName: '状态',
      remark: '备注',
      fetchError: '获取费用详情失败'
    },
    staffDetailApplyReturnFee: {
      selectState: '选择状态',
      returnFeeId: '退费ID',
      detailId: '详情ID',
      feeTypeCdName: '费用类型',
      payerObjName: '付款对象',
      cycles: '周期',
      receivableAmount: '应收金额',
      receivedAmount: '实收金额',
      createTime: '创建时间',
      reason: '原因',
      applyPersonName: '申请人',
      stateName: '状态',
      auditPersonName: '审核人',
      fetchError: '获取退费数据失败',
      fetchDictError: '获取字典数据失败'
    },
    staffDetailContract: {
      contractId: '合同ID',
      contractNo: '合同编号',
      contractName: '合同名称',
      partyA: '甲方',
      partyB: '乙方',
      contractPeriod: '合同周期',
      stateName: '状态',
      fetchError: '获取合同数据失败'
    },
    staffDetailAppAuth: {
      authId: '认证ID',
      appName: '应用名称',
      authTime: '认证时间',
      stateName: '状态',
      fetchError: '获取应用认证数据失败'
    },
    staffDetailAccessControl: {
      accessId: '门禁ID',
      deviceName: '设备名称',
      syncTime: '同步时间',
      stateName: '状态',
      fetchError: '获取门禁数据失败'
    }
  },
  'zh-TW': {
    adminStaffDetail: {
      title: '員工信息',
      staffId: '編號',
      userName: '名稱',
      idCard: '身份證',
      tel: '手機',
      sex: '性別',
      male: '男',
      female: '女',
      address: '住址',
      privilege: '組織權限',
      classes: '排班',
      attendance: '考勤',
      repair: '維修',
      inspection: '巡檢',
      maintainance: '保養',
      purchaseApply: '採購',
      itemOutApply: '領用',
      hisFee: '收費單',
      applyReturnFee: '退費單',
      contract: '起草合同',
      appAuth: '員工認證',
      accessControl: '人臉同步',
      fetchError: '獲取員工信息失敗'
    },
    staffDetailPrivilege: {
      orgs: '組織',
      orgName: '組織名稱',
      relCdName: '關係代碼',
      roles: '角色',
      privileges: '權限',
      fetchPrivilegesError: '獲取權限失敗',
      fetchOrgsError: '獲取組織失敗',
      fetchRolesError: '獲取角色失敗'
    },
    staffDetailClasses: {
      enterDate: '輸入日期 (YYYY-MM)',
      rest: '休息',
      fetchError: '獲取排班數據失敗'
    },
    staffDetailAttendance: {
      enterDate: '輸入日期 (YYYY-MM)',
      checkIn: '簽到',
      checkOut: '簽退',
      attendanceLog: '考勤記錄',
      notYet: '尚未到達',
      noAttendance: '無考勤',
      fetchError: '獲取考勤數據失敗'
    },
    staffAttendanceDetail: {
      title: '考勤記錄',
      face: '人臉圖像',
      staffName: '員工名稱',
      clockTime: '打卡時間',
      fetchError: '獲取考勤記錄失敗'
    },
    staffDetailRepair: {
      undoOrder: '待處理',
      doneOrder: '已完成',
      repairId: '維修ID',
      location: '地點',
      repairType: '維修類型',
      maintenanceType: '維護類型',
      paidService: '付費服務',
      freeService: '免費服務',
      materialRequired: '需要材料',
      noMaterial: '無需材料',
      repairPerson: '維修人員',
      contact: '聯繫方式',
      appointmentTime: '預約時間',
      status: '狀態',
      timedTask: '定時任務',
      fetchError: '獲取維修數據失敗'
    },
    staffDetailInspection: {
      notStarted: '未開始',
      inProgress: '進行中',
      completed: '已完成',
      taskDetailId: '任務詳情ID',
      inspectionName: '巡檢名稱',
      inspectionPlanName: '計劃名稱',
      routeName: '路線名稱',
      planTime: '計劃時間',
      pointTime: '點時間',
      actualInspectionTime: '實際巡檢時間',
      inspectionState: '巡檢狀態',
      planUserName: '計劃用戶',
      actualUserName: '實際用戶',
      signType: '簽到類型',
      taskState: '任務狀態',
      description: '描述',
      photos: '照片',
      createTime: '創建時間',
      location: '位置',
      noLocation: '無位置數據',
      fetchError: '獲取巡檢數據失敗'
    },
    staffDetailMaintainance: {
      notStarted: '未開始',
      pendingCheck: '待審核',
      completed: '已完成',
      taskDetailId: '任務詳情ID',
      machineName: '設備名稱',
      planName: '計劃名稱',
      standardName: '標準名稱',
      planUserName: '計劃用戶',
      planTime: '計劃時間',
      actualInspectionTime: '實際巡檢時間',
      actualUserName: '實際用戶',
      taskState: '任務狀態',
      description: '描述',
      photos: '照片',
      createTime: '創建時間',
      fetchError: '獲取保養數據失敗'
    },
    staffDetailPurchaseApply: {
      applyOrderId: '申請訂單ID',
      userName: '用戶名',
      endUserName: '最終用戶名',
      createUserName: '創建用戶名',
      resourceNames: '資源名稱',
      createTime: '創建時間',
      warehousingWay: '入庫方式',
      direct: '直接',
      purchase: '採購',
      urgent: '緊急',
      stateName: '狀態',
      fetchError: '獲取採購申請數據失敗'
    },
    staffDetailItemOutApply: {
      applyOrderId: '申請訂單ID',
      resourceNames: '資源名稱',
      userName: '用戶名',
      createUserName: '創建用戶名',
      createTime: '創建時間',
      stateName: '狀態',
      warehousingWay: '入庫方式',
      direct: '直接',
      review: '審核',
      fetchError: '獲取領用申請數據失敗'
    },
    staffDetailHisFee: {
      feeName: '費用名稱',
      payerObjName: '付款對象',
      cycles: '週期',
      amount: '金額',
      acctAmount: '帳戶金額',
      primeRateName: '主要費率',
      feePeriod: '費用週期',
      createTime: '創建時間',
      cashierName: '收銀員名稱',
      stateName: '狀態',
      remark: '備註',
      fetchError: '獲取費用詳情失敗'
    },
    staffDetailApplyReturnFee: {
      selectState: '選擇狀態',
      returnFeeId: '退費ID',
      detailId: '詳情ID',
      feeTypeCdName: '費用類型',
      payerObjName: '付款對象',
      cycles: '週期',
      receivableAmount: '應收金額',
      receivedAmount: '實收金額',
      createTime: '創建時間',
      reason: '原因',
      applyPersonName: '申請人',
      stateName: '狀態',
      auditPersonName: '審核人',
      fetchError: '獲取退費數據失敗',
      fetchDictError: '獲取字典數據失敗'
    },
    staffDetailContract: {
      contractId: '合同ID',
      contractNo: '合同編號',
      contractName: '合同名稱',
      partyA: '甲方',
      partyB: '乙方',
      contractPeriod: '合同週期',
      stateName: '狀態',
      fetchError: '獲取合同數據失敗'
    },
    staffDetailAppAuth: {
      authId: '認證ID',
      appName: '應用名稱',
      authTime: '認證時間',
      stateName: '狀態',
      fetchError: '獲取應用認證數據失敗'
    },
    staffDetailAccessControl: {
      accessId: '門禁ID',
      deviceName: '設備名稱',
      syncTime: '同步時間',
      stateName: '狀態',
      fetchError: '獲取門禁數據失敗'
    }
  }
};